import './LegalizationSection.css';

export function LegalizationSection() {
  return (
    <section className="legalization-section">
      <div className="legalization-section__inner">
        <span className="legalization-section__icon">📢</span>
        <h2 className="legalization-section__title">Hemp Beverage Legalization</h2>
        <p className="legalization-section__desc">
          Hemp-derived THC beverages are legal in most states under the 2018 Farm Bill, but some
          states have enacted restrictions or outright bans. New legislation threatens access
          to hemp beverages nationwide.
        </p>

        <div className="legalization-section__columns">
          <div className="legalization-section__col">
            <h3 className="legalization-section__col-title legalization-section__col-title--banned">
              Banned States (8)
            </h3>
            <p className="legalization-section__col-desc">
              Idaho, Mississippi, Iowa, North Dakota, Rhode Island, Hawaii, Vermont, Arkansas
            </p>
          </div>
          <div className="legalization-section__col">
            <h3 className="legalization-section__col-title legalization-section__col-title--restricted">
              Restricted States (6)
            </h3>
            <p className="legalization-section__col-desc">
              Oregon, Washington, Alaska, California, Colorado, Arizona
              <span className="legalization-section__col-note">(dispensary only)</span>
            </p>
          </div>
          <div className="legalization-section__col">
            <h3 className="legalization-section__col-title legalization-section__col-title--legal">
              Legal (All Other States)
            </h3>
            <p className="legalization-section__col-desc">
              The 2018 Farm Bill applies. Hemp-derived THC beverages with &lt;0.3% THC by dry
              weight are federally legal.
            </p>
          </div>
        </div>

        <p className="legalization-section__disclaimer">
          Hygh Vybe is an informational review platform. We do not sell products directly.
          Please check your local laws regarding THC beverages before purchasing from any retailer.
        </p>

        <a
          href="https://hempsupporter.com/bill/help-stop-the-hemp-ban/"
          target="_blank"
          rel="noopener noreferrer"
          className="legalization-section__cta"
        >
          <span className="legalization-section__cta-icon">🗳️</span>
          <span className="legalization-section__cta-text">
            <strong>Help protect hemp access</strong>
            <span>New legislation threatens hemp beverages. Contact your senators and make your voice heard.</span>
          </span>
          <span className="legalization-section__cta-arrow">→</span>
        </a>
      </div>
    </section>
  );
}
